import { hrcConstants, siteConstants } from '../../constants'
import { hrcServices } from '../../services'
import { alertActions }  from '.'

const listHrcGuidance = () => {
  const request = () => {
    return {
      type: hrcConstants.LIST_HRC_GUIDANCE_REQUEST,
      payload: null,
    }
  }

  const success = (data) => {
    return {
      type: hrcConstants.LIST_HRC_GUIDANCE_SUCCESS,
      payload: { data },
    }
  }

  const failure = () => {
    return {
      type: hrcConstants.LIST_HRC_GUIDANCE_FAILURE,
      payload: null,
    }
  }

  return dispatch => {
    dispatch(request())
    hrcServices.listHrcGuidance()
      .then(response => {
        const data = response.data
        dispatch(success(data))
      })
      .catch(error => {
        if (error.response)
          dispatch(alertActions.error(error.response.data.detail || siteConstants.ERROR_MSG_SERVER_COMMUNICATION))
        else
          dispatch(alertActions.error(siteConstants.ERROR_MSG_SERVER_COMMUNICATION))

        dispatch(failure())
      })
  }
}

const updateHrcGuidance = (file) => {
  const request = (file) => {
    return {
      type: hrcConstants.UPDATE_HRC_GUIDANCE_REQUEST,
      payload: { file },
    }
  }

  const success = (data) => {
    return {
      type: hrcConstants.UPDATE_HRC_GUIDANCE_SUCCESS,
      payload: { data },
    }
  }

  const failure = () => {
    return {
      type: hrcConstants.UPDATE_HRC_GUIDANCE_FAILURE,
      payload: null,
    }
  }

  return dispatch => {
    dispatch(request(file))
    hrcServices.updateHrcGuidance(file)
      .then(response => {
        const data = response.data
        dispatch(success(data))
      })
      .catch(error => {
        if (error.response)
          dispatch(alertActions.error(error.response.data.detail || siteConstants.ERROR_MSG_SERVER_COMMUNICATION))
        else
          dispatch(alertActions.error(siteConstants.ERROR_MSG_SERVER_COMMUNICATION))
      })
  }
}

export const hrcActions = {
  listHrcGuidance,
  updateHrcGuidance,
}
